<template>
  <div class="form">
    <div class="form__header">
      <h3>Оставить обратную связь</h3>

      <div class="help" uk-lightbox="video-autoplay:true;" uk-tooltip="Как оставлять обратную связь">
        <a href="https://www.youtube.com/watch?v=1kkXxyPhXbs" data-caption="YouTube">
          <img src="/themes/genius/assets/img/question.svg" alt="">
        </a>
      </div>
    </div>

    <div class="form__body">
      <FeedbackExample />
      <AddReport 
        :atClass="atClass" 
        :student_id="data.id" 
        @loadPastReports="onLoadPastReports"
        @add-report="addReport" />

      <div class="os_t__reports" v-if="reports.length > 0">
        <ul class="myclass__accord" uk-accordion>
          <FeedbackItem v-for="item in reports" :key="item.id" :item="item" />
        </ul>
      </div>

      <div v-else>Обратная связь не найдена</div>
    </div>
  </div>
</template>

<script>
import AddReport from './AddReport'
import FeedbackItem from './FeedbackItem'
import FeedbackExample from './FeedbackExample'

export default {
  name: "feedback",
  data() {
    return {
      reports: []
    }
  },
  components: { AddReport, FeedbackItem, FeedbackExample },
  props: ['data', 'atClass'],
  methods: {
    addReport(report) {
      this.data.student_reports.unshift(report);
      this.$emit('close-popup') 
      swal('Успешно!', 'Обратная связь добавлена', 'success')     
    },
    onLoadPastReports(reports) {
      this.reports = reports;
    }
  },
}
</script>

<style lang="scss" scoped>
.form__header {
  display: flex;
  align-items: center;
}
.help {
  margin-left: 10px;
  width: 30px;
  height: 30px;
}
</style>